import { cardPreviewContext } from '@context/card-preview-context';
import { useCardAttribute } from '@hooks/use-card-attributes';
import { useContext } from 'react';

import { SingleInputCardProperty } from '../SingleInputCardProperty';
import styles from './JobTitle.module.scss';
import type { CardProperty } from '.cache/__types__';

type JobTitleProps = {
  property?: CardProperty;
  // In future, cardId could come from the cardFieldEditContext (or similar context), that way we can tell if there is no
  // cardId, that we need to create a new card before adding the property.
  cardId: string;
};

export const JobTitle: React.FC<JobTitleProps> = ({ property, cardId }) => {
  const { hideEmptyAttributes } = useContext(cardPreviewContext);

  const cardAttributeType = useCardAttribute('job_title');
  if (!cardAttributeType) {
    return null;
  }

  // if hideEmptyAttributes specified as true and property value empty, then job title shouldn't be shown on the card at all
  if (hideEmptyAttributes && !property?.value) {
    return <></>;
  }

  return (
    <div className={styles['user-job-title-container']}>
      <SingleInputCardProperty
        attribute={cardAttributeType}
        cardId={cardId}
        className={styles['user-job-title']}
        inputLabel="Job Title"
        property={property}
        defaultTemplateValueProvider={'member'}
      />
    </div>
  );
};
